import React, {useState} from "react";
import { Input, Button, Tooltip, Table, DatePicker, Select, TimePicker, Popconfirm } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/zh_CN';
import RefuseExamine from './com/refuseExamine'
import UserInfo from "../../components/UserInfo";

import './index.sass'
import api from "../../utils/api";
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect} from "react-redux";

const { RangePicker } = DatePicker;

class GroupsExamine extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            change_fans_flag: 1,
            dataSource: []
        }
    }


    componentDidMount() {
        this.verifyGbList();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value) {
            this.verifyGbList();
        }
        return true;
    }

    verifyGbList = async () => {//获取团购审核列表

        let { change_fans_flag } = this.state;


        let param = {

            type: change_fans_flag

        }

        let res = await api('verify-gb-list', param);
        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }

        console.log(res)

    }

    change_fans_type = (flag) => {
        this.setState({
            change_fans_flag: flag,
            show_refuse: false
        })
    }

    refuse_handle = (ctx) => {
        this.setState({
            show_refuse: true
        })
    }

    render() {
        let { change_fans_flag, show_refuse, dataSource } = this.state;

        const columns = [
            {
                title: '团购名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '团购类型',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '团长昵称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '团长手机号',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '团长地址',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '申请时间',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex aglinCenter' >
                            <Popconfirm
                                title='确定同意该团长开团？'
                            >
                                <div className='pointer mgr10 themeColor'>同意</div>
                            </Popconfirm>

                            <div className='pointer warn' onClick={() => { this.refuse_handle(ctx) }}>拒绝</div>

                        </div>
                    )
                }
            },
        ];


        const columns_refuse = [
            {
                title: '团购名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '团购类型',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '团长昵称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '团长手机号',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '团长地址',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '申请时间',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '审核结果',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '拒绝原因',
                dataIndex: 'age',
                key: 'age',
            },
        ];

        const HeaderRight = () => {
            let [merchant] = useState(this.props.merchant);
           return <ul className='flex census'>
               <li>
                   <label>全部商户</label>
                   <p>{merchant.merchantFansCount}</p>
               </li>
               <li>
                   <label>全部粉丝</label>
                   <p>{merchant.userFansCount}</p>
               </li>
           </ul>;
        }
        return (
            <div className='groupExamine'>
                {/* 头部 */}
                <UserInfo rightBox={<HeaderRight/>} />
                <div className='record'>
                    <div className='change_fans'>
                        <ul className='flex tabs'>
                            <li className={change_fans_flag === 1 ? 'active' : ''} onClick={() => { this.change_fans_type(1) }}>待审核</li>
                            <li className={change_fans_flag === 2 ? 'active' : ''} onClick={() => { this.change_fans_type(2) }}>已审核</li>
                        </ul>
                    </div>
                    <div className='change_fans flex'>
                        <div className='flex line alignCenter mgr40'>
                            申请时间：
                            <RangePicker locale={locale} />
                        </div>
                        <Button className='themeBtn mgr10' icon={<SearchOutlined />}>搜索</Button>
                        <Button>重置</Button>
                    </div>
                    <div className='change_fans'>
                        <Table dataSource={dataSource} columns={change_fans_flag === 0 ? columns : columns_refuse} />
                    </div>
                </div>
                {
                    show_refuse ? (
                        <RefuseExamine colsePop={(e) => { this.setState({ show_refuse: e.show }) }} />
                    ) : null
                }
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(GroupsExamine);